import { render, staticRenderFns } from "./inquiryTem.vue?vue&type=template&id=90f975a6&scoped=true"
import script from "./inquiryTem.vue?vue&type=script&lang=js"
export * from "./inquiryTem.vue?vue&type=script&lang=js"
import style0 from "./inquiryTem.vue?vue&type=style&index=0&id=90f975a6&prod&lang=scss&scoped=true"
import style1 from "./inquiryTem.vue?vue&type=style&index=1&id=90f975a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f975a6",
  null
  
)

export default component.exports